import { Grid, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { Paper } from '@roc/ui';
import { sanitizeHtml } from '@roc/ui/utils';
import { WarningOutlined, ErrorOutline } from '@material-ui/icons';
const useStyles = makeStyles(theme => ({
  paper: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    backgroundColor: '#FEF0ED',
    color: '#642B20',
    marginBottom: '-26px',
  },
  messageBox: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    backgroundColor: '#FEF0ED',
    color: '#642B20',
    borderRadius: 16
  },
  content: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
  },
  icon: {
    color: theme.palette.warning.light,
  },
  titleContainer: {
    paddingBottom: '0px !important'
  }
}));
export const NewUiBannerMessages = observer((props) => {
  const classes = useStyles();
  const { messages } = props;
  const { newDesignForSummaryScreen } = props;
  let messageComponents = [];
  messageComponents = messages && messages.map(message => {
    const content: string = message.content;
    return (
      <Grid container className={classes.content} spacing={2}>
        <Grid item>
          {newDesignForSummaryScreen ? <ErrorOutline className={classes.icon} /> : <WarningOutlined className={classes.icon} />}
        </Grid>
        <Grid item xs={11} className={classes.titleContainer}>
          <Typography>
            <strong>
              {message.title}
            </strong>
            <br />
            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}></div>
          </Typography>
        </Grid>
      </Grid >
    );
  }
  );
  return (
    <>
      {messages?.length > 0 ? (
        <>
          {!newDesignForSummaryScreen && <Paper className={classes.paper} title="">
            {messageComponents}
          </Paper>}
          {newDesignForSummaryScreen && <Box className={classes.messageBox} >{messageComponents}</Box>}
          <br />
        </>) : <Grid />
      }
    </>
  );
});